export function redirectWithLine() {
  if (navigator.userAgent.indexOf('Line') === -1) return;
  window.location.href = '?openExternalBrowser=1';
}

export function redirectWithAndroidFb() {
  let isFbav = navigator.userAgent.indexOf('FBAV') !== -1;
  let isFban = navigator.userAgent.indexOf('FBAN') !== -1;
  let isAndroid = navigator.userAgent.indexOf("Android") !== -1;
  if (!(isFbav || isFban) || !isAndroid) return;
  let url = window.location.href;
  setTimeout(function () {
    location.href = "intent:" + url + "#Intent;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;component=com.android.browser/com.android.browser.BrowserActivity;end";
  }, 500);
}